import { IconButton, styled } from '@mui/material'

export const ScrollDownButton = styled(IconButton)(() => ({
    position: 'absolute',
    top: '-40px',
    right: '20px',
    marginLeft: 'auto',
    zIndex: '1000',
    border: '1px solid #E9EAED',
    backgroundColor: '#ffffff',
    '&:hover': {
        backgroundColor: '#F9FAFB',
    },
}))
